import colleague from './colleague';

export default { colleague };
